import { useState, useLayoutEffect } from 'react'

function queryObjectToString(query) {
  const QUERY_COMBINATOR = ' and '

  if (typeof query === 'string') {
    return query
  }

  return Object.entries(query)
    .map(([feature, value]) => {
      const convertedFeature = feature.replace(/[A-Z]/g, string => `-${string.toLowerCase()}`).toLowerCase()
      let convertedValue = value

      if (typeof convertedValue === 'boolean') {
        return convertedValue ? convertedFeature : `not ${convertedFeature}`
      }

      if (typeof convertedValue === 'number' && /[height|width]$/.test(convertedFeature)) {
        convertedValue = `${convertedValue}px`
      }

      return `(${convertedFeature}: ${convertedValue})`
    })
    .join(QUERY_COMBINATOR)
}

const mockMediaQueryList = {
  media: '',
  matches: false,
  onchange: () => {},
  addListener: () => {},
  removeListener: () => {},
  addEventListener: () => {},
  removeEventListener: () => {},
  dispatchEvent: _ => true,
}

const defaultQuery = {
  maxWidth: '768px',
}

const useMedia = (rawQuery = defaultQuery, defaultState = false) => {
  const query = queryObjectToString(rawQuery)

  const [state, setState] = useState(defaultState)
  useLayoutEffect(() => {
    let mounted = true
    const mediaQueryList = typeof window === 'undefined' ? mockMediaQueryList : window.matchMedia(query)
    const onChange = () => {
      if (!mounted) {
        return
      }

      setState(Boolean(mediaQueryList.matches))
    }

    mediaQueryList.addListener(onChange)
    setState(mediaQueryList.matches)

    return () => {
      mounted = false
      mediaQueryList.removeListener(onChange)
    }
  }, [query])

  return state
}

export default useMedia
